module.exports = __webpack_public_path__ + "img/shuixi13.1428955d.png";